import React from 'react';
import { Smile, ShieldCheck, Zap } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const DentistryPage = () => {
  const config = {
    badge: "Dental Sanctuary",
    headline: "Oral Health",
    headlineItalic: "Excellence.",
    subtext: "Comprehensive dental care from professional scaling to complex oral surgeries, keeping your pet's smile healthy and pain-free.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Veterinary Dentistry at Dr. Suresh Pet Care — Oral Care Excellence",
    stats: [
      { value: 2000, suffix: '+', label: 'Dental Procedures' },
      { value: 99, suffix: '%', label: 'Patient Comfort Rate' },
      { value: 7, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Care' },
    ],
    services: [
      {
        title: "Dental Scaling & Polishing",
        icon: <Smile size={28} />,
        desc: "Professional ultrasonic scaling to remove plaque and tartar, restoring clean, healthy gum lines.",
        specs: ["Ultrasonic Scaling", "Subgingival Cleaning", "Dental Polishing", "Fluoride Treatment"],
        color: "from-blue-500/10 to-primary/10"
      },
      {
        title: "Oral Surgery",
        icon: <ShieldCheck size={28} />,
        desc: "Precision extraction of fractured, diseased, or retained teeth with minimal recovery trauma.",
        specs: ["Tooth Extraction", "Fractured Tooth Repair", "Jaw Surgery", "Post-Op Care"],
        color: "from-primary/10 to-cyan-500/10"
      },
      {
        title: "Oral Health Diagnostics",
        icon: <Zap size={28} />,
        desc: "Advanced dental radiography and periodontal probing for a complete picture of oral health status.",
        specs: ["Dental X-rays", "Periodontal Probing", "Oral Cancer Screening", "Treatment Planning"],
        color: "from-teal-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Dental",
    sectionItalic: "Capabilities.",
    warningTitle: "Dental Health",
    warningItalic: "Warning Signs.",
    warningText: "Oral disease is one of the most common — and preventable — conditions in pets. Early intervention protects systemic health.",
    warnings: [
      { name: "Bad Breath", desc: "Persistent halitosis often signals bacterial infection or periodontal disease.", icon: "💨" },
      { name: "Difficulty Eating", desc: "Dropping food or chewing on one side may indicate tooth pain or abscess.", icon: "🦷" },
      { name: "Excessive Drooling", desc: "Unusual salivation can indicate oral pain, ulcers, or foreign objects.", icon: "💧" },
      { name: "Pawing at the Mouth", desc: "Repeated face-pawing is a classic sign of oral discomfort or tooth injury.", icon: "🐾" },
    ],
    ctaBadge: "Dental Speciality",
    ctaTitle: "The Dental",
    ctaItalic: "Expertise.",
    ctaText: "Our dental unit uses precision instruments and modern anaesthesia protocols for a safe, comfortable experience for every patient in Hyderabad.",
    ctaBtn: "Book Dental Check",
    seoText: "Professional veterinary dentistry in Hyderabad. Dog dental scaling and tooth extraction at Dr. Suresh Pet Care. Advanced oral care and dental surgery for pets.",
    glowColor: "cyan-500"
  };

  return (
    <>
      <SEO 
        title="Veterinary Dentistry & Oral Care"
        description="Professional dental scaling, tooth extraction, and oral health management for pets at Dr. Suresh Pet Care in Hyderabad."
        canonical="/dentistry"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};

export default DentistryPage;
